// extracted by mini-css-extract-plugin
module.exports = {"arrowNavigation":"SliderButton_arrowNavigation__slbwU"};